module.exports = __webpack_public_path__ + "Unhealthy.3d41162733ecc5a83efe2ad732350987.hashedasset.svg";